<template>
  <div class="summary-container">
    <div class="summary">
      <h2>Payment Summary</h2>
      <div class="summary-table">
        <div>
          <p>Product Name</p>
          <p @click="saveCustomerProduct">{{ packageType.name }}</p>
        </div>
        <div>
          <p>Product Description</p>
          <p>{{ packageType.productDescription }}</p>
        </div>
        <div class="table-base">
          <p>Product Amount</p>
          <p>NGN {{ packageType.amountOS ? packageType.amountOS.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</p>
        </div>
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        Review the package choice and click continue to make payment!
      </div>
      <img :src="require('../../../../assets/img/polygon.svg')" class="polygon" alt="Comment Bubble">
      <img :src="require('../../../../assets/img/female-wave.gif')" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OSSummary",
  props: [ "updateStatus", "updateTracker" ],
  computed: {
    ...mapGetters(["getUserSession"]),
  },
  data() {
    return {
      packageType: {
        name: '',
        productDescription: '',
        amountOS: 0,
        id: 0,
      },
    };
  },
  methods: {
    saveCustomerProduct() {
      const HTTP = this.$httpUtils.instance;

      const data = {
        customerId: this.getUserSession.id,
        productid: this.packageType.id,
        tenure: '6',
        firstPaymentAmt: '1181000',
        monthlyIncomeRange: '>1000000',
        employmentStatus: 'employed',
        totalPayment: '3065000',
        cautionFee: '0',
        setupFee: '0',
      };

      HTTP
        .post(`/CustomerProductOptions`, data)
        .catch(err => console.log(err));
    },
    async getCustomerProduct() {
      const HTTP = this.$httpUtils.instance;

      let customerProductId = await HTTP.get(`/CustomerProductOptions?filter={"where":{"customerId":${this.getUserSession.id}},"order":"id DESC","limit":"1"}`);
      let res = await HTTP.get("/arnergyProducts");

      let productPackage = res.data.filter(item => item.id === customerProductId.data[0].productid)
      let customerProduct = {
        id: productPackage[0].id,
        name: productPackage[0].productType,
        amountOS: productPackage[0].amountOS,
        productDescription: productPackage[0].productDescription,
      }

      this.$store.commit("saveOnboardingPackageType", customerProduct);
      return customerProduct
    },
  },
  async mounted() {
    this.updateTracker(true);
    this.packageType = this.$store.state.onboardingPackageType;
    if (this.packageType.name) this.saveCustomerProduct();
    else this.packageType = await this.getCustomerProduct();
    this.updateStatus(2);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1, h2, h3, h4, p {
    margin: 0;
    padding: 0;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
}


p {
  color: #000000;
  font-size: 16px;
  line-height: 24px;
}

.summary-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.summary {
  width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #FAFAFA;
    /* width: 70%; */
    /* min-width: 289px; */

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #E8E2E2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius:40px;
  padding: 32px 20px;
  background: #E6F6FF;
  text-align: center;
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892D0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

</style>


// WEBPACK FOOTER //
// src/components/pages/onboarding/outrightSale/OSSummary.vue